module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxkExlR2MysFCBK8OirNw2kM.woff2";